<template>
<div>
  <main> 
    <NavBar :title="'AI MODEL DEVELOPMENT'"
            :titleIcon="'mdi-percil-ruler'"
            :menuItems= menuItems
            />
    <v-container class="pt-10 mt-10" >
          <v-slide-x-transition mode="out-in">
            <router-view/>
          </v-slide-x-transition>
    </v-container>
</main>
</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'

  export default {
    name: 'ManageAi',
    components: { NavBar},
    data () {   
      return {
        menuItems: [ 
          { title:'AI Model Development', routeName:'AlloyDesignAdditive', routeParams:{}}
        ]
      }
    }
  }
</script>
